import MainClass, { MAIN_CLASS_PARAMS } from '../../utils/mainClass.ts';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

class SubMasthead extends MainClass {
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.selector && this.init();
	}

	initAnimation = () => {
		const getOtherSection = Array.prototype.slice.call(this.selector.closest('.raise-body')?.querySelectorAll('&>*:not([data-call="SubMasthead"])'))
		const heading = this.selector.querySelector( '.raise-masthead-heading' ) as HTMLElement;
		const label = this.selector.querySelector( '.raise-masthead-eyebrow' ) as HTMLElement;
		const description = this.selector.querySelector( '.raise-masthead-description' ) as HTMLElement;
		const imageBlock = this.selector.querySelector( '.raise-masthead-image-wrapper' ) as HTMLElement;
		const cta = this.selector.querySelector( 'a' ) as HTMLElement;
		gsap.registerPlugin( ScrollTrigger );
		gsap.set(getOtherSection,{opacity:0})
		let tl = gsap.timeline( {
			scrollTrigger: {
				trigger: this.selector,
				start: 'top center',
			},
		} );

		if ( heading ) {
			tl.fromTo(
				heading,
				{
					opacity: 0,
					y: '100%',
				},
				{
					opacity: 1,
					y: 0,
					duration: 0.5,
					ease: 'power1.inOut',
				},
				1,
			);
		}

		if ( label ) {
			tl.fromTo(
				label,
				{
					opacity: 0,
					y: '100%',
				},
				{
					opacity: 1,
					y: 0,
					duration: 0.5,
					ease: 'power1.inOut',
					delay: 0.1,
				},
				1,
			);
		}

		if ( description ) {
			tl.fromTo(
				description,
				{
					opacity: 0,
					y: '100%',
				},
				{
					opacity: 1,
					y: 0,
					duration: 0.5,
					ease: 'power1.inOut',
					delay: label ? 0.2 : 0.1,
				},
				1,
			);
		}

		if ( cta ) {
			tl.fromTo(
				cta,
				{
					opacity: 0,
					y: '100%',
				},
				{
					opacity: 1,
					y: 0,
					duration: 0.4,
					ease: 'power1.inOut',
					delay: label && description ? 0.3 : 0.2,
				},
				1,
			);
		}

		if ( imageBlock ) {
			tl.fromTo(
				imageBlock,
				{
					opacity: 0,
					x: '100%',
					scale: 1.5,
				},
				{
					opacity: 1,
					x: 0,
					duration: 0.5,
					scale: 1,
					ease: 'power1.inOut',
				},
				1,
			);
		}
		tl.to(getOtherSection,{opacity:1,delay:.5})
	};

	init() {
		this.initAnimation();
		const description = this.selector.querySelector( '.raise-masthead-text-wrapper .raise-masthead-description' ) as HTMLElement;
		if ( description ) {
			const brTag = Array.from(description.querySelectorAll( 'br' )) as HTMLElement[];
			if ( brTag.length > 0 ) {
				brTag.forEach((br: HTMLElement) => {
					const spacer = document.createElement('div');
					spacer.className = 'break-text-spacer';
					br?.parentNode?.replaceChild(spacer, br);
				  });
				
			}
		}
	}
}

export default SubMasthead;
